import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Empty } from 'antd';
import Icofont from 'react-icofont';

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

import {
    MoreOutlined
} from '@ant-design/icons';



import { Action, deleteInArray, updateInArray } from 'fennec-ui'
import { DropdownAction } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'

import "./index.css"
import KategoryaUchastnikovSeriiUpdate from '../KategoryaUchastnikovSeriiUpdate';
import KategoryaUchastnikovSeriiCreate from '../KategoryaUchastnikovSeriiCreate';
import uuid from 'react-uuid';

const DragHandle = sortableHandle(() => <Icofont icon="expand-alt" style={{ cursor: 'grabbing', color: '#999' }} />);
const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);


export default function KategoriiUchastnikovSerii(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, item, sourceKey, create, collection, setCollection } = props;
    const dispatch = useDispatch();
    const _kategorii = (object.kategoriiUchastnikovSeriiSeriya) ? [...object.kategoriiUchastnikovSeriiSeriya] : [];
    const kategorii = _kategorii.sort((a, b) => {
        return a.sort - b.sort;
    }).map((item, index) => {
        return { ...item, sort: index };
    });

    const kat_delete = React.useCallback((kat) => {
        if (!create) return;
        POST(auth, "/api/serii/kategoriiuchastnikovserii/delete", kat,
            () => {
                setCollection(o => updateInArray(o, {
                    ...object,
                    kategoriiUchastnikovSeriiSeriya: deleteInArray(object.kategoriiUchastnikovSeriiSeriya, kat)
                }))
            },
            (err) => errorCatch(err));
    }, [sourceKey, object]);
    const postSetOrder = (kategorii) => {
        if (!create) return;
        setLoading(true);
        POST(auth, "/api/serii/kategoriiuchastnikovserii/sort", kategorii,
            ({ data }) => {
                setCollection(o => updateInArray(o, {
                    ...object,
                    kategoriiUchastnikovSeriiSeriya: data
                }))
                setLoading(false);
            },
            (err) => errorCatch(err, setLoading(false)));
    };
    const columns = () => {
        var c = [];

        if (create) {
            c.push({
                width: 30,
                className: 'drag-visible',
                render: () => <DragHandle />,
            });
        }
        c.push({
            title: 'Танцевальная дисциплина',
            render: (text, record) => {
                return (
                    <div>
                        {record.tantsevalnayaDistsiplina.nazvanie}
                    </div>
                );
            },
            key: 'tantsevalnayaDistsiplina',
        });
        c.push({
            title: 'Категория участников',
            render: (text, record) => {
                return (
                    <div>
                        {record.kategoriyaUchastnikov.nazvanie}
                    </div>
                );
            },
            key: 'kategoriyaUchastnikov',
        });
        if (create) {
            c.push({
                title: <span style={{fontSize: "11px",fontWeight: "300"}}>Количество лучших результатов в итоговой сумме (коэф. 1)</span>,
                render: (text, record) => {
                    return (
                        <div style={{textAlign:"center"}}>
                            {record.kolvoLuchshikhRezKoef1}
                        </div>
                    );
                },
                key: 'kategoriyaUchastnikov',
            });
            c.push({
                title: <span style={{fontSize: "11px",fontWeight: "300"}}>Количество лучших результатов в итоговой сумме (коэф. 2)</span>,
                render: (text, record) => {
                    return (
                        <div style={{textAlign:"center"}}>
                            {record.kolvoLuchshikhRezKoef2}
                        </div>
                    );
                },
                key: 'kategoriyaUchastnikov',
            });
            c.push({
                title: <span style={{fontSize: "11px",fontWeight: "300"}}>Подсвечивать зеленым сумму более или равную</span>,
                render: (text, record) => {
                    return (
                        <div style={{textAlign:"center"}}>
                            {record.podsvechivatZelenim}
                        </div>
                    );
                },
                key: 'kategoriyaUchastnikov',
            });
            c.push({
                title: <span style={{fontSize: "11px",fontWeight: "300"}}>Подсвечивать лучших результатов</span>,
                render: (text, record) => {
                    return (
                        <div style={{textAlign:"center"}}>
                            {record.podsvechivatLuchshikhRezultatov}
                        </div>
                    );
                },
                key: 'kategoriyaUchastnikov',
            });
            // c.push({
            //     title: '',
            //     dataIndex: '',
            //     key: 'move',
            //     fixed: 'right',
            //     width: 45,
            //     render: (text, record) => {
            //         return (<div style={{lineHeight: "0"}}>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => kat_move("up", record)}><Icofont icon="caret-up"/></Button>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => kat_move("down", record)}><Icofont icon="caret-down"/></Button>
            //             </div>
            //         );
            //     },
            // });
            c.push({
                title: '',
                dataIndex: '',
                key: 'x',
                fixed: 'right',
                width: 45,
                render: (text, record) => {
                    return (
                        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                            {
                                ...props,
                                readonly: false,
                                mode: "MenuItem",
                                auth: auth,
                                context: object,
                                object: record,
                                action: (values, unlock, close) => updateAction(record, values, unlock, close),
                                form: KategoryaUchastnikovSeriiUpdate,
                                title: "Изменить",
                                modal: {
                                    title: "Изменить",
                                    minWidth: "600px",
                                }
                            },
                            {
                                title: "Удалить",
                                mode: "MenuItem",
                                action: () => kat_delete(record)
                            }
                        ]} />);
                },
            });
        }

        return c;
    };
    const updateAction = (record, values, unlock, close) => {
        if (!create) return;
        POST(auth, "/api/serii/kategoriiuchastnikovserii/update", { ...record, ...values },
            ({ data }) => {
                if (data) {
                    setCollection(o => updateInArray(o, {
                        ...object,
                        kategoriiUchastnikovSeriiSeriya: updateInArray(object.kategoriiUchastnikovSeriiSeriya, data)
                    }))
                }
                close();
            },
            (err) => errorCatch(err, unlock));
    };
    const createAction = (values, unlock, close) => {
        if (!create) return;
        POST(auth, "/api/serii/kategoriiuchastnikovserii/new", { ...values, seriyaID: object.ID },
            ({ data }) => {
                if (data) {
                    setCollection(o => updateInArray(o, {
                        ...object,
                        kategoriiUchastnikovSeriiSeriya: updateInArray(object.kategoriiUchastnikovSeriiSeriya, data)
                    }))
                }
                close();
            },
            (err) => errorCatch(err, unlock));
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const dataSource = kategorii;
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
            postSetOrder(newData);
        }
    };

    const DraggableContainer = props => (
        <SortableContainer
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const dataSource = kategorii;
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex(x => x.sort === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    return (
        <>
            {create && <Action
                // {...props}
                // uuid={uuid()}
                readonly={false}
                triggerStyle={{ marginBottom: "5px" }}
                triggerOptions={{
                    type: "primary"
                }}
                auth={auth}
                action={createAction}
                form={KategoryaUchastnikovSeriiCreate}
                title={"Добавить категорию участников"}
                modal={{
                    // width: "55%",
                    minWidth: "400px",
                }}
                mode={"button"}
            />}
            <Table
                loading={loading}
                columns={columns()}
                pagination={false}
                dataSource={kategorii}
                locale={{ emptyText: <Empty description={"Нет категорий участников"}></Empty> }}
                size="small"
                rowKey={r => r.sort}
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                    },
                }}
            />
        </>
    );
}
